import { render, staticRenderFns } from "./ColorPickerInlinePopupElement.vue?vue&type=template&id=c6b339f2&"
import script from "./ColorPickerInlinePopupElement.vue?vue&type=script&lang=js&"
export * from "./ColorPickerInlinePopupElement.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerInlinePopupElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VColorPicker,VIcon,VMenu})
